import { render, staticRenderFns } from "./TransactionOrderForm.vue?vue&type=template&id=d6dec318&"
import script from "./TransactionOrderForm.vue?vue&type=script&lang=js&"
export * from "./TransactionOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports